export const isLandlineNumberWithShortPrefix = (number) => [
    '010',
    '013',
    '015',
    '020',
    '023',
    '024',
    '026',
    '030',
    '033',
    '035',
    '036',
    '038',
    '040',
    '043',
    '045',
    '046',
    '050',
    '053',
    '055',
    '058',
    '070',
    '071',
    '072',
    '073',
    '074',
    '075',
    '076',
    '077',
    '078',
    '079',
    '088',
].some((prefix) => new RegExp(`^${prefix}`).test(number));
